const SectionForPartners = Class(
	/**
	 * @lends {SectionForPartners#}
	 */
	{
		__NAME: 'SectionForPartners',

		background: null,
		bodyClass: 'small-nav',
		menuItem: 'for-partners',

		draw: function () {
			let heroUrl = {
				tag: 'a',
				className: 'button button-large button-pink',
				text: D.Lang.get('for-partners.welcome.button')
			};
			if( D.Lang.get('for-partners.welcome.button.link') === 'contact-us' ) {
				heroUrl.onclick = function () {
					D.scrollIntoView(document.querySelector('.corporate-form-wrapper'));
				};
			} else {
				heroUrl.href = D.url(D.Lang.get('for-partners.welcome.button.link'));
			}

			new T.Hero({
				className: 'hero-simple hero-simple-partners',
				backgroundClass: `background-picture-for-partners`,
				title: mkE({
					tag: 'span',
					innerHTML: D.Lang.get('for-partners.welcome.title')
				}),
				text: D.Lang.get('for-partners.welcome.text'),
				button: mkE(heroUrl),
				simple: true
			}).append(this.layout.ct());


			mkE({
				tag: 'div',
				els: [
					{
						tag: 'div',
						className: 'container for-partners-info',
						els: [
							{
								tag: 'div',
								className: 'bs-row',
								els: [
									{
										tag: 'div',
										className: 'col-lg-6',
										els: [
											{
												tag: 'h2',
												text: D.Lang.get('for-partners.how.title')
											},
											{
												tag: 'h4',
												className: 'sub',
												text: D.Lang.get('for-partners.how.sub_title')
											},
											{
												tag: 'h4',
												text: D.Lang.get('for-partners.how.list_title')
											},
											{
												tag: 'ul',
												className: 'default-list default-list-small',
												innerHTML: D.Lang.get('for-partners.how.list')
											}
										]
									},
									{
										tag: 'div',
										className: 'col-lg-6',
										els: [
											{
												tag: 'h2',
												text: D.Lang.get('for-partners.what.title')
											},
											{
												tag: 'ul',
												className: 'default-list default-list-small',
												innerHTML: D.Lang.get('for-partners.what.list')
											}
										]
									}
								]
							}
						]
					}
				]
			}).append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'corporate-form-wrapper contact-form-wrapper',
				els: [
					new T.ContactUs()
				]
			}).append(this.layout.ct());

			this.ready();
		}

	},
	Section
);